import util from '../util'

let controller = 'OperadorRetaguardaMfa'
export default Object.assign({}, util.GetCrud(controller, null), {
    SMS: function (dto) {
        return util.Axios.Post(controller + "/OperadorRetaguardaSMS", dto)
    },
    EMAIL: function (dto) {
        return util.Axios.Post(controller + "/OperadorRetaguardaEmail", dto)
    },
    GetSolcitacaoEmAberto: function (id) {
        return util.Axios.GetAll(controller + `/GetSolicitacaoEmAbertoRetaguarda?codigoOperador=${id}`, {})
    },
})